// @flow
import {
	FormControlLabel,
	FormControl,
	FormLabel,
	RadioGroup,
	Radio, FormHelperText,
} from '@mui/material';
import { Controller } from 'react-hook-form';
import type { radiobuttonType } from '@shared/model/components';
import { useState } from 'react';
import findNestedValue from '@shared/utils/findNestedValue';
import HelperText from '@shared/components/helperText';

function Radiobutton({
	id,
	groupLabel,
	name,
	control,
	errors,
	schema,
	items,
	comment,
	color,
	isHorizontal = true,
	defaultValue,
	...radioButtonProps
}: radiobuttonType): React$Node {

	const [isRequired] = useState(
		schema?.describe()?.fields[name]?.tests?.some((test) => test.name === 'required') || false,
	);

	return (
		<Controller
			name={name}
			defaultValue={defaultValue || items[0]?.value}
			control={control}
			render={({ field }) => {
				const foundError = findNestedValue(errors, name);

				return (<FormControl component={'fieldset'} error={Boolean(foundError)} required={isRequired}>
					{groupLabel && (<FormLabel component={'legend'}>{groupLabel}</FormLabel>)}
					<RadioGroup
						id={id}
						row={isHorizontal}
						name={'row-radio-buttons-group'}
						{...field}
					>
						{items.map((item) => {
							const { value, title, id: itemId, ...props } = item;
							return (<FormControlLabel
								value={value}
								key={itemId}
								id={`item-${value}`}
								control={<Radio {...radioButtonProps} color={color} {...props} />}
								label={title}
							/>);
						})}
					</RadioGroup>
					<FormHelperText>
						<HelperText message={foundError?.message || comment} />
					</FormHelperText>
				</FormControl>)
			}}
		/>
	);
}

export default Radiobutton;
